module.exports = __webpack_public_path__ + "img/monoid-dark.938dec35.png";